import { Link } from 'react-router-dom';

const Dashboard = () => {
    return (
        <div>
            <h1 className="text-3xl font-bold text-white mb-8">Yönetim Paneli</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <Link to="/admin/events" className="group">
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 group-hover:border-cyan-500/50 group-hover:bg-gray-700/50 transition-all h-full">
                        <h3 className="text-lg font-semibold text-gray-200 mb-2 group-hover:text-cyan-400">Etkinlik Yönetimi</h3>
                        <p className="text-gray-400 text-sm mb-4">Etkinlikleri ekle, düzenle veya kaldır.</p>
                    </div>
                </Link>

                <Link to="/admin/announcements" className="group">
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 group-hover:border-cyan-500/50 group-hover:bg-gray-700/50 transition-all h-full">
                        <h3 className="text-lg font-semibold text-gray-200 mb-2 group-hover:text-cyan-400">Duyuru Yönetimi</h3>
                        <p className="text-gray-400 text-sm mb-4">Yeni duyurular yayınla.</p>
                    </div>
                </Link>

                <Link to="/admin/team" className="group">
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 group-hover:border-cyan-500/50 group-hover:bg-gray-700/50 transition-all h-full">
                        <h3 className="text-lg font-semibold text-gray-200 mb-2 group-hover:text-cyan-400">Ekip Yönetimi</h3>
                        <p className="text-gray-400 text-sm mb-4">Yönetim kurulu ve üyeleri güncelle.</p>
                    </div>
                </Link>

                <Link to="/admin/blogs" className="group">
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 group-hover:border-cyan-500/50 group-hover:bg-gray-700/50 transition-all h-full">
                        <h3 className="text-lg font-semibold text-gray-200 mb-2 group-hover:text-cyan-400">Blog Yönetimi</h3>
                        <p className="text-gray-400 text-sm mb-4">Köşe yazılarını yönet.</p>
                    </div>
                </Link>

                <Link to="/admin/magazines" className="group">
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 group-hover:border-cyan-500/50 group-hover:bg-gray-700/50 transition-all h-full">
                        <h3 className="text-lg font-semibold text-gray-200 mb-2 group-hover:text-cyan-400">Dergi Yönetimi</h3>
                        <p className="text-gray-400 text-sm mb-4">Dergileri yükle ve düzenle.</p>
                    </div>
                </Link>
                <Link to="/admin/press" className="group">
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 group-hover:border-cyan-500/50 group-hover:bg-gray-700/50 transition-all h-full">
                        <h3 className="text-lg font-semibold text-gray-200 mb-2 group-hover:text-cyan-400">Basında Biz</h3>
                        <p className="text-gray-400 text-sm mb-4">Haberleri ve basında çıkanları yönet.</p>
                    </div>
                </Link>
            </div>
        </div>
    );
};

export default Dashboard;
